/**
 * @generated SignedSource<<a4e473fa32b5caa8e845c58056c3f108>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamFeatureBarSignalItem_team$data = {
  readonly activeCount: number;
  readonly hasHighPrioritySignals: boolean;
  readonly signalUnreadCount: number | null;
  readonly unreadCount: number;
  readonly " $fragmentType": "TeamFeatureBarSignalItem_team";
};
export type TeamFeatureBarSignalItem_team$key = {
  readonly " $data"?: TeamFeatureBarSignalItem_team$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamFeatureBarSignalItem_team">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "employeeId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamFeatureBarSignalItem_team",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unreadCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "activeCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "employeeId",
          "variableName": "employeeId"
        }
      ],
      "kind": "ScalarField",
      "name": "signalUnreadCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasHighPrioritySignals",
      "storageKey": null
    }
  ],
  "type": "SignalTeamFeature",
  "abstractKey": null
};

(node as any).hash = "08848234ef0e2f19edc226b2f08ad719";

export default node;
